export const nav = [
  { path: '/', name: 'home', label: '首页' },
  { path: '/service', name: 'service', label: '心晴服务' },
  { path: 'appointment', name: 'appointment', label: '预约心晴' },
  { path: '/news', name: 'news', label: '心晴动态' },
  { path: '/medicine', name: 'medicine', label: '药品信息' },
  { path: '/about', name: 'about', label: '关于心晴' }
]

export const newsType = {
  EXPERT: '专家专题',
  PSYCHOLOGY: '心理杂谈',
  LECTURE: '活动讲座',
  INDUSTRY_INFORMATION: '精彩阅读'
}



// WEBPACK FOOTER //
// ./src/config/code.js